import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.less'
import App from './App';
import * as serviceWorker from './serviceWorker';
import {ConfigProvider, Spin} from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import {LoadingOutlined} from '@ant-design/icons';
import {createStore} from "redux";
import reducer from "./pages/redux/reducers";
import {Provider} from "react-redux";

const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;
Spin.setDefaultIndicator(antIcon);

const store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), //开发者工具配置项
);

ReactDOM.render(
    <ConfigProvider locale={zh_CN}>
        <Provider store={store}>
            <App/>
        </Provider>
    </ConfigProvider>, document.getElementById('container'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
